/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import SplashPage from "../../components/splash";
import useAuth from "../../hooks/useAuth";
import { getUserInfo } from "../../actions/user";
import { setAddress } from "../../utils/geocode";
import { Backend, Frontend } from "shared-types";
import { message } from "antd";

export const EmailVerifyPage: React.FC = () => {
  const { token } = useParams();
  const { login, dispatchUser } = useAuth() as any;
  const geolocationAPI = navigator.geolocation;
  const ourLocation = {
    lat: 52.48546014466491,
    lon: 13.34604,
  };

  const getUserCoordinates = async () => {
    if (!geolocationAPI) {
      console.log("Geolocation API is not available in your browser!");
      setDefaultLocation();
    } else {
      geolocationAPI.getCurrentPosition(
        async (position) => {
          const { coords } = position;
          if (coords.latitude > -1000000 && coords.longitude > -1000000) {
            setAddress(coords.latitude, coords.longitude)
              .then(async () => {
                await getUserInfo().then((response) => {
                  dispatchUser(response.data.userInfo);
                }).catch(console.warn);
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            setDefaultLocation();
          }
        },
        async (error) => {
          console.log("Something went wrong getting your position!");
          setDefaultLocation();
        }
      );
    }
  };

  const setDefaultLocation = () => {
    setAddress(ourLocation.lat, ourLocation.lon).then(() => {
      getUserInfo().then((response) => {
        dispatchUser(response.data.userInfo);
      }).catch(console.warn);
    });
  };

  useEffect(() => {
    const initialize = async () => {
      if (token) {
        let postData: Backend.T_SignInForm = {
          type: "email-verify",
          token: token,
        };
        let res: Frontend.T_Response<{}>["data"] = await login(postData);
        if(res.status) {
          await getUserCoordinates();
          window.location.href = "/track/new";
        }
        else {
          message.error(res.message, 3000);
          setTimeout(() => {
            window.location.href = '/login';
          }, 3000);
        }
      }
    };

    initialize();
  }, [token]);
  return <SplashPage />;
};
